// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__1j9QM","line":"style_line__2ZoyO","title":"style_title__3Gptv","value":"style_value__qnllN"};